import { imageAsset, linkTo, manualResources } from "queries"

const relatedTags = `
relatedTag {
  ...on issueArea_Entry {
    id
    typeHandle
    slug
  }
}`

export const relatedNews = `
query($id: [QueryArgument], $relatedTo:[QueryArgument], $type:[String], $tag:[QueryArgument], $limit:Int, $storyType:[QueryArgument]) {
  entries(section: ["news", "press"], type: $type, id: $id, limit: $limit, relatedTo: $relatedTo, relatedToAll: $tag, storyType: $storyType) {
    id
    title
    uri
    sectionHandle
    ...on news_Entry {
      title
      typeHandle
      newsTag {
        id
        title
        slug
      }
      locationTag {
        id
        title
        slug
      }
      heading
      image {
        ${imageAsset}
      }
      date
    }
    ...on story_Entry {
      typeHandle
      storyType
      heading
      image {
        ${imageAsset}
      }
      copy
      date
    }
    ...on profile_Entry {
      typeHandle
      heading
      image {
        ${imageAsset}
      }
      copy
      date
    }
    ...on action_Entry {
      typeHandle
      heading
      date
      image {
        ${imageAsset}
      }
    }
    ...on press_Entry {
      typeHandle
      source: copy
      date
      linkUrl
      image {
        ${imageAsset}
      }
    }
  }
}`

const author = `
staffMember {
  id
  title
  slug
  typeHandle
}`

export const newsQuery = `query($slug: [String]) {
  entries(section: "news", slug: $slug, orderBy: "dateUpdated desc") {
    id
    title
    uri
    ...on action_Entry {
      typeHandle
      heading
      date
      image {
        ${imageAsset}
      }
      heroImage {
        ${imageAsset}
      }
      imageAsBackground
      body
      embedOnTop
      embed
      ${linkTo}
      ${relatedTags}
      ${manualResources}
    }
    ...on news_Entry {
      title
      typeHandle
      newsTag {
        id
        title
        slug
      }
      locationTag {
        id
        title
        slug
      }
      heading
      date
      body
      embedOnTop
      embed
      image {
        ${imageAsset}
      }
      heroImage {
        ${imageAsset}
      }
      imageAsBackground
      articleAuthor: ${author}
      ${relatedTags}
    }
    ...on story_Entry {
      typeHandle
      storyType
      heading
      image {
        ${imageAsset}
      }
      date
      copy
      body
      embedOnTop
      embed
      articleAuthor: ${author}
      ${relatedTags}
    }
    ...on profile_Entry {
      typeHandle
      heading
      image {
        ${imageAsset}
      }
      date
      copy
      body
      embedOnTop
      embed
      articleAuthor: ${author}
    }
  }
}`

export const storiesQuery = `
query($id: [QueryArgument],$relatedTo:[QueryArgument],$limit:Int) {
  entries(section: "news", type: "story", id: $id, limit: $limit, relatedTo: $relatedTo) {
    id
    title
    uri
    sectionHandle
    ...on story_Entry {
      typeHandle
      storyType
      heading
      image {
        ${imageAsset}
      }
      copy
      date
    }
  }
}
`